import React, { useEffect, memo } from 'react';
import { initTrackingScripts } from '../lib/tracking-scripts';
import { attachAnalyticsListeners } from '@spotify-internal/touchdown-analytics';
import Page from '../../shared/components/Page';
import { globalTracer } from 'opentracing';

export type SpotiDataType = typeof window.SPOTI_DATA;

const App = (props: SpotiDataType) => {
  const {
    baseElement,
    parentSpan: indexSpan,
    user,
    language,
    pageName,
    resourceName,
    market,
    country,
    forceOneTrust,
    pageData,
    direction,
    embedded,
  } = props;

  const tracer = globalTracer();
  const appSpan = tracer.startSpan('app', { childOf: indexSpan });

  const pageProps = {
    market,
    direction,
    user,
    pageData,
    embedded,
    language,
    parentSpan: appSpan,
  };

  useEffect(() => {
    if (language) {
      initTrackingScripts({
        forceOneTrust,
        market,
        language,
        loggedIn: user.authenticated,
      });
    }
  }, [forceOneTrust, market, language, user.authenticated]);

  useEffect(() => {
    attachAnalyticsListeners({
      analyticsRoot: baseElement,
      isAuthenticated: user.authenticated ?? false,
      pageName,
      resourceName,
      language,
      countryCode: country ?? '',
      eventParams: pageData.eventParams ?? {},
    });
  }, [
    baseElement,
    user.authenticated,
    pageName,
    resourceName,
    language,
    country,
    pageData.eventParams,
  ]);

  appSpan.finish();

  return <Page {...pageProps} />;
};

export default memo(App);
